export default __webpack_public_path__ + "static/media/web_1_2.07cbf7c5.png";